export const TABS = ['typy', 'sloty', 'dostawcy', 'ustawienia', 'raw'] as const

export type Tab = (typeof TABS)[number]

export function isTab(v: string | undefined): v is Tab {
  return !!v && (TABS as readonly string[]).includes(v)
}
